import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  withHandlers,
  withState,
  lifecycle,
} from 'recompose';
import { bindActionCreators } from 'redux';
import { usersAction } from '@/actions';

import { constants } from '../../../../constants';

const mapStateToProps = (state) => ({ users: state.users.toJS() });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...usersAction }, dispatch);

const enhance = compose(
  setDisplayName('UserFollow'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isPaginationDisabled', 'updatePaginationDisabled', false),
  withState('isLoading', 'updateLoading', false),
  withHandlers({
    onChangePage: (props) => async (current) => {
      window.scrollTo({ left: 0, top: 75, behavior: 'instant' });

      const {
        getFollowPagination,
        updateFollowPagesActive,
        updatePaginationDisabled,
        users: {
          mydata: { id },
        },
      } = props;

      updatePaginationDisabled(true);
      updateFollowPagesActive(current);

      await getFollowPagination({ limit: 5, current: current, userId: id }, [
        '-created_at',
      ]);
      updatePaginationDisabled(false);
    },
  }),
  lifecycle({
    async componentDidMount() {
      const {
        getFollowPagination,
        updateFollowPagesActive,
        getMe,
        updateLoading,
        getMyFollows,
      } = this.props;

      updateLoading(true);
      const me = await getMe();
      const userId = me.value.id;
      await getFollowPagination(
        { limit: 5, current: constants.PAGINATION.INITIAL, userId },
        ['-created_at']
      );
      updateFollowPagesActive(constants.PAGINATION.INITIAL);
      getMyFollows(userId);
      updateLoading(false);
    },
  })
);

export default enhance;
